<template v-if="list.length > 0">
    <div class="hot">
        <div class="container">
            <!-- title -->
            <home-title :title="'竞赛资讯'" :moreUrl="'/information'" />
            <div class="info-item" v-for="info in list" :key="info.id" @click="handleCLickItem(info)">
                <div class="info-item-left" style="-webkit-box-orient: vertical;">
                    <div class="title">{{ info.title }}</div>
                    <span>{{ info.createdAt | dateFormat }}</span>
                </div>
                <div class="info-item-right" style="-webkit-box-orient: vertical;">
                    <img :src="info.bannerUrl" :alt="info.title" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import HomeTitle from './HomeTitle.vue';
import moment from 'moment';

export default {
    data() {
        return {
            list: [],
        };
    },

    components: { HomeTitle },

    computed: {
        user() {
            return this.$store.getters.userInfo;
        },
    },

    methods: {
        async getData() {
            const {
                status,
                data: { list },
            } = await this.$axios('fetchInformationsJson', {
                pageIndex: 1,
                pageSize: 3,
                homeShow: 0,
                label: 0,
            });
            this.list = list;
        },
        handleCLickItem(item) {
            this.$router.push(`/information/${item.id}`);
        },
    },

    created() {
        this.getData();
    },
    filters: {
        dateFormat(val) {
            return moment(val).format('YYYY-MM-DD');
        },
    },
};
</script>

<style lang="scss" scoped>
.hot {
    margin-top: 22px;
    padding: 0 14px;
    .container {
        padding-top: 12px;
        width: 724px;
        max-height: 912px;
        overflow: hidden;
        background: #ffffff;
        border-radius: 28px;
        .info-item {
            width: 686px;
            margin: 0 auto;
            padding: 0 8px;
            height: 216px;
            display: flex;
            justify-content: space-between;
            padding-top: 42px;
            padding-bottom: 40px;
            border-bottom: 2px solid #f3f3f4;
            &:nth-last-of-type(1) {
                border-bottom: none;
            }
        }
        .info-item-left {
            width: 420px;
            position: relative;
            .title {
                margin: 0;
                font-size: 28px;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 500;
                color: #232526;
                overflow: hidden;
                width: 420px;
                height: 80px;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                line-height: 40px;

                display: -webkit-box;
                /* autoprefixer: off */
                -webkit-box-orient: vertical;
                /* autoprefixer: on */
                -webkit-line-clamp: 2;
                overflow: hidden;
            }
            span {
                position: absolute;
                left: 0;
                bottom: 0;
                font-size: 22px;
                color: #666869;
            }
        }
        .info-item-right {
            img {
                width: 200px;
                height: 138px;
                border-right: 12px;
                border-radius: 8px;
            }
        }
    }
}
</style>
